import React from 'react';
import PropTypes from 'prop-types';
// import { Card } from 'reactstrap';
import Table from 'app/components/general/Table';
import PaymentBadge from 'app/components/general/PaymentBadge';
import classnames from 'classnames';
import _ from 'lodash';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
// Misc
//

export default class EventReport extends React.Component {
  static propTypes = {
    handleEventClick: PropTypes.func,
    isLoading: PropTypes.bool,
    paymentEventIds: PropTypes.array,
    paymentEventsById: PropTypes.object,
  };

  static defaultProps = {
    handleEventClick: undefined,
    paymentEventIds: undefined,
    paymentEventsById: undefined,
    isLoading: false,
  };

  constructEventReportData = (paymentEventsById, paymentEventIds) => {
    if (
      paymentEventsById !== undefined
      && !_.isEmpty(paymentEventsById)
      && paymentEventIds !== undefined
    ) {
      const paymentEventData = paymentEventsSelectors.getPaymentEventReport(
        this.props.paymentEventsById,
        this.props.paymentEventIds,
      );
      return paymentEventData;
    }
    return [];
  };

  render(): React.ReactNode {
    const data = this.constructEventReportData(
      this.props.paymentEventsById,
      this.props.paymentEventIds,
    );
    const columns = [
      {
        Header: 'Payment Method',
        className: 'col col-3',
        headerClassName: 'col col-3',
        accessor: 'paymentMethod',
        Cell: (cellProps) => (
          <PaymentBadge
            className="event-card-badge mr-auto"
            tick={false}
            paymentText={cellProps.value}
          />
        ),
      },
      {
        Header: '# of Payments',
        accessor: 'numberOfPayments',
        className: 'col col-3',
        headerClassName: 'col col-3',
      },
      {
        Header: 'Rate ($)',
        accessor: 'paymentRate',
        className: 'col col-3',
        headerClassName: 'col col-3',
      },
      {
        Header: 'Total ($)',
        accessor: 'paymentTotal',
        className: 'col col-3',
        headerClassName: 'col col-3',
      },
    ];

    return (
      <div className="with-margin-top">
        <Table
          headerTitle="Payment Report"
          objectTitle="payment report"
          filterable={false}
          showPagination={false}
          isLoading={this.props.isLoading}
          data={data}
          columns={columns}
        />
      </div>
    );
  }
}
